import API from "@app/services/api";
import type { DatasetPurpose, DatasetState } from "@app/utils/reference-dataset";
import type { SearchPage } from "@app/utils/use-paginated-search";

export interface DatasetPickerItem {
  id: string;
  name: string;
  description: string | null;
  file_count: number;
  purpose?: DatasetPurpose;
  state?: DatasetState;
}

/** One page of the datasets the session may open, searched on name and description. */
export async function fetchDatasetPickerPage(
  search: string,
  offset: number,
): Promise<SearchPage<DatasetPickerItem>> {
  const res = await API.get({
    path: "/dataset/for-select",
    query: { search: search || undefined, offset },
  });
  if (!res.ok || !res.data) throw new Error(res.error);
  return {
    rows: res.data.datasets as DatasetPickerItem[],
    total: res.data.pagination.total as number,
  };
}
